module.exports = __webpack_public_path__ + "static/media/border-outer.f9dd6a5c.svg";